import { createContext, useContext, useState } from "react";

export const QuizContext = createContext();

export const useQuiz = () => {
  return useContext(QuizContext);
};

export const QuizProvider = ({ children }) => {
  const [quizData, setQuizData] = useState({
    category: "",
    difficulty: "",
    type: "",
    amount: "",
    score: "",
    name: "",
    email: "",
  });

  const setCategory = (value) => {
    setQuizData({ ...quizData, category: value });
  };

  const setDifficulty = (value) => {
    setQuizData({ ...quizData, difficulty: value });
  };

  const setType = (value) => {
    setQuizData({ ...quizData, type: value });
  };

  const setAmount = (value) => {
    setQuizData({ ...quizData, amount: value });
  };
  const setScore = (value) => {
    setQuizData({ ...quizData, score: value });
  };
  const setName = (value) => {
    setQuizData({ ...quizData, name: value });
  };
  const setEmail = (value) => {
    setQuizData({ ...quizData, Email: value });
  };

  return (
    <QuizContext.Provider
      value={{
        quizData,
        setCategory,
        setDifficulty,
        setType,
        setAmount,
        setScore,
        setName,
        setEmail,
      }}
    >
      {children}
    </QuizContext.Provider>
  );
};
